<script>
import formatDate from '@utils/format-date'
import formMixin from "./mixins/form";
import addDays from "date-fns/addDays";
import getISODay from "date-fns/getISODay";
import parseISO from "date-fns/parseISO";
import { authComputed, merchantComputed } from '@store/helpers'
import {
  getDefaultCategory,
  getDefaultDate,
  getDefaultIsUsePrepaid,
  getDefaultIsUserMemberPet,
  getDefaultPetId,
  getDefaultReservationDisabledDayList,
  getDefaultSizeAlias
} from "@utils/ipetbooking-get-default";
import {
  getMemberPetOption,
  memberPetOptions,
  sizeOptions,
} from "@utils/ipetbooking-options";

const DEFAULT_SUBMIT_DATA = {
  sizeAlias: '',
  petId: '',
};

export default {
  name:'FormReservationPrepaid.Jtails',
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    buttonText: {
      type: String,
      default: '查看可用的包套',
    },
    tempSubmitData: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    memberPetOptions,
    memberPetItem() {
      return getMemberPetOption({
        value: this.FormMixSubmitData.petId,
        type: 'item'
      })
    },
  },
  watch: {
    'FormMixSubmitData.petId'(newValue, oldValue) {
      if(newValue === 'new') {
        this.FormMixSubmitData.petId = oldValue;

        this.openDialogPet();
      }
    },
  },
  created() {
    const initFormMixSubmitData = () => {
      const {
        category,
        sizeAlias,
        isUserMemberPet,
        petId,
      } = this.$route.query;

      this.FormMixSubmitData.category = petId
        ? (getDefaultCategory(category) || DEFAULT_SUBMIT_DATA.category)
        : '';
      this.FormMixSubmitData.petId = petId
        ? (getDefaultPetId(petId) || DEFAULT_SUBMIT_DATA.petId)
        : '';
      this.FormMixSubmitData.sizeAlias = petId
        ? (getDefaultSizeAlias({
            queryIsUserMemberPet: isUserMemberPet,
            queryPetId: petId,
            querySize: sizeAlias,
            queryCategory: category
          }) || DEFAULT_SUBMIT_DATA.sizeAlias)
        : '';
    };

    initFormMixSubmitData();
    this.$FormMixinOnInit()
  },
  methods: {
    formatDate,
    sizeOptions,
    getDefaultReservationDisabledDayList,
    onSubmit() {
      this.$FormMixinOnSubmitSuccess()
    },
    callbackNewPet(submitData) {
      this.FormMixSubmitData.petId = submitData.id
    },
    onChangePetId(petId) {
      if (petId === 'new') return

      const setFormMixSubmitDataSizeAlias = () => {
        const memberPetItem = getMemberPetOption({
          value: petId,
        });

        this.FormMixSubmitData.category = memberPetItem.categoryAlias || '';
        this.FormMixSubmitData.sizeAlias = memberPetItem.sizeAlias || '';
      };

      setFormMixSubmitDataSizeAlias();
      this.onSubmit();
    },
    openDialogPet() {
      this.$globalDialog('DialogPet', {
        type: 'add',
        callbackNewPet: (submitData) => {
          this.FormMixSubmitData.petId = submitData.id;

          this.onChangePetId(submitData.id);
        }
      })
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.formReservationStore">
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <!--isIncludDisabledDayList ? '該日期非營業時間，請選擇其他日期'-->
      <el-form
        ref="form"
        :model="FormMixSubmitData"
        label-position="top"
        class="isStyleBase"
        @submit.prevent.native="handleSubmit(onSubmit)"
      >
        <div class="formReservationStore__bottomBox">
          <template v-if="!!currentMemberPetList && !!currentMemberPetList[0]">
            <ValidationProvider
              v-slot="{ errors }"
              :name="`我的${$t('site.USER')}`"
              rules="require"
            >
              <el-form-item :error="''" prop="petId" label="">
                <el-select
                  v-model="FormMixSubmitData.petId"
                  placeholder=""
                  class="isStylePet2"
                  popper-class="isStylePet"
                  @change="onChangePetId"
                >
                  <div slot="prefix">
                      <template v-if="FormMixSubmitData.petId">
                        <span
                          class="prefix__img"
                          :style="{ backgroundImage: `url('${ memberPetItem.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
                        ></span>
                        <span class="prefix__meta">
                          <span class="prefix__title">
                            {{ memberPetItem.text }}
                          </span>
                          <span v-if="$globalCategoryVisible" class="prefix__category">
                            {{ memberPetItem.categoryTitle }} | {{ memberPetItem.sizeTitle }}
                          </span>
                        </span>
                      </template>
                      <template v-else>
                        <span class="pl-3">
                          選擇{{ $t('site.USER') }}
                          <br>篩選該{{ $t('site.USER') }}可用的{{`${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}`}}
                        </span>
                      </template>
                  </div>
                  <el-option
                    v-for="(option, $index) in memberPetOptions"
                    :key="`memberPetOptions-${$index}`"
                    :label="option.text"
                    :value="option.value"
                  >
                    <div class="option__item">
                          <span
                            class="option__img"
                            :style="{ backgroundImage: `url('${ option.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
                          ></span>
                      <span class="option__content">
                            <span class="option__text">{{ option.text }}</span>
                            <span  v-if="$globalCategoryVisible" class="option__category">{{ option.categoryTitle }} | {{ option.sizeTitle }}</span>
                          </span>
                    </div>
                  </el-option>
                  <el-option
                    :label="`新增${$t('site.USER')}`"
                    value="new"
                    class="isNew"
                  >
                    <i class="fal fa-plus mr-2"></i>新增{{ $t('site.USER') }}
                  </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
          </template>
          <template v-else>
              <span>
                <div class="el-form-item">
                  <!--<label class="el-form-item__label">我的寵物(請先新增寵物)</label>-->
                  <BaseButton
                    class="isStyleSecondary isFull"
                    :class="{ 'isRadius': $globalIsJtails }"
                    @click="openDialogPet"
                  >
                    <i class="fal fa-plus"></i> 新增{{ $t('site.USER') }}
                  </BaseButton>
                  <div class="fs-2sm text-center mt-2">新增{{ $t('site.USER') }}，篩選該{{ $t('site.USER') }}可用的{{`${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}`}}</div>
                </div>
              </span>
          </template>
        </div>
        <!-- <div class="formReservationStore__submitBox">
          <BaseButton
            :disabled="invalid"
            :loading="$isLoading('fetchPrepaidOrderList') || $isLoading('fetchReservationList')"
            type="submit"
            class="isStylePrimary isRadius isFull formReservationStore__submit"
          >
            <span v-html="buttonText"></span>
          </BaseButton>
        </div> -->
      </el-form>
    </ValidationObserver>
    <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.formReservationStore {
  // margin-bottom: -22px;

  :global {
    .formReservationStore {
      &__submit {
        margin-top: 3px;
        // margin-bottom: 22px;
      }

      &__bottomBox {
        // padding: 1.5rem 1.5rem 0;
      }

      &__submitBox {
        // padding: 0 1.5rem 1.5rem;
      }
    }
  }
}
</style>
